<template>
  <v-card class="elevation-0 mb-3">
    <v-card-text
      v-for="terms in termsList"
      :key="terms.id"
      :class="{'not-required': !isRequired(terms)}"
    >
      <w-schema :model="model">
        <v-checkbox :label="termsLabel(terms)" :value="terms.id" />
      </w-schema>

      <a target="_blank" :href="mediaUrl(terms)">Pobierz regulamin</a>
    </v-card-text>
  </v-card>
</template>

<script>
import { WSchema } from '@witkac/vuetify-components';

import { config } from '@/utils/config';

// @vuese
// Input do zaznacania udzielonych zgód
export default {
  components: { WSchema },
  props: {
    // model zgód
    model: {
      type: Object,
      required: true
    },
    // lista regulaminów
    termsList: {
      type: Array,
      required: true
    }
  },
  methods: {
    // @vuese
    // Zwraca adres do pobrania pliku
    mediaUrl(terms) {
      return `${config.mediaURL}/${terms.mediaId}`;
    },

    // @vuese
    // Zwraca label checkboxa regulaminu
    termsLabel(terms) {
      return `Akceptuję ${terms.name} ${terms.required ? '*' : ''}`;
    },

    // @vuese
    // Sprawdza, czy regulamin jest wymagany i niezaakceptowany
    isRequired(terms) {
      return terms.required && !this.model.$model.includes(terms.id);
    }
  }
};
</script>

<style>
</style>